<template>
  <div>
    <div class="notification is-warning is-margin-bottom-xsmall">
      <p class="is-size-7 has-text-primary has-text-weight-medium">
        Vous pouvez choisir les sujets ainsi que les modes de notifications afin que cela corresponde au mieux à votre façon de travailler
      </p>
    </div>
    <form
      @submit.prevent.stop="submit"
      class="is-clipped">
      <div class="columns is-multiline is-padding is-border-bottom">
        <div class="column is-12">
          <p class="title is-5">
            Mode de notification
          </p>
        </div>
        <div class="column is-10">
          <r-label
            label="Notifications Push"
            :is-required="false"
            :for="'push_alert_enabled'"></r-label>
        </div>
        <div class="column is-2 has-text-right">
          <input
            id="push_alert_enabled"
            type="checkbox"
            name="push_alert_enabled"
            v-model="params.push_alert_enabled"
            class="switch is-success is-rounded is-small">
          <label
            for="push_alert_enabled"
            class="is-right"></label>
        </div>
        <div class="column is-10">
          <r-label
            label="Notifications mails"
            :is-required="false"
            :for="'email_alert_enabled'"></r-label>
        </div>
        <div class="column is-2 has-text-right">
          <input
            id="email_alert_enabled"
            type="checkbox"
            name="email_alert_enabled"
            v-model="params.email_alert_enabled"
            class="switch is-success is-rounded is-small">
          <label for="email_alert_enabled"></label>
        </div>
        <div class="column is-10">
          <r-label
            label="Notifications SMS"
            :is-required="false"
            :for="'sms_alert_enabled'"></r-label>
        </div>
        <div class="column is-2 has-text-right">
          <input
            id="sms_alert_enabled"
            type="checkbox"
            name="sms_alert_enabled"
            v-model="params.sms_alert_enabled"
            class="switch is-success is-rounded is-small">
          <label
            for="sms_alert_enabled"
            class="is-right"></label>
        </div>
      </div>
      <div class="columns is-multiline is-padding is-border-bottom">
        <div class="column is-12">
          <p class="title is-5">
            Evènements
          </p>
        </div>
        <div
          class="column is-10">
          <r-label
            label="Notifications leads"
            :is-required="false"
            :for="'lead_alert'"></r-label>
        </div>
        <div
          class="column is-2 has-text-right">
          <input
            id="lead_alert"
            type="checkbox"
            name="lead_alert"
            v-model="params.lead_alert"
            class="switch is-success is-rounded is-small">
          <label
            for="lead_alert"
            class="is-right"></label>
        </div>
        <div class="column is-10">
          <r-label
            label="Notifications options"
            :is-required="false"
            :for="'option_alert'"></r-label>
        </div>
        <div class="column is-2 has-text-right">
          <input
            id="option_alert"
            type="checkbox"
            name="option_alert"
            v-model="params.option_alert"
            class="switch is-success is-rounded is-small">
          <label for="option_alert"></label>
        </div>
        <div class="column is-10">
          <r-label
            label="Notifications dénonciations"
            :is-required="false"
            :for="'claim_alert'"></r-label>
        </div>
        <div class="column is-2 has-text-right">
          <input
            id="claim_alert"
            type="checkbox"
            name="claim_alert"
            v-model="params.claim_alert"
            class="switch is-success is-rounded is-small">
          <label
            for="claim_alert"
            class="is-right"></label>
        </div>
        <div class="column is-10">
          <r-label
            label="Notifications ADV"
            :is-required="false"
            :for="'reservation_and_sale_alert'"></r-label>
        </div>
        <div class="column is-2 has-text-right">
          <input
            id="reservation_and_sale_alert"
            type="checkbox"
            name="reservation_and_sale_alert"
            v-model="params.reservation_and_sale_alert"
            class="switch is-success is-rounded is-small">
          <label
            for="reservation_and_sale_alert"
            class="is-right"></label>
        </div>
        <div
          class="column is-10"
          v-if="isAdmin && isPromoteur">
          <r-label
            label="Notifications tickets"
            :is-required="false"
            :for="'relation_partner_alert'"></r-label>
        </div>
        <div
          class="column is-2 has-text-right"
          v-if="isAdmin && isPromoteur">
          <input
            id="relation_partner_alert"
            type="checkbox"
            name="relation_partner_alert"
            v-model="params.relation_partner_alert"
            class="switch is-success is-rounded is-small">
          <label
            for="relation_partner_alert"
            class="is-right"></label>
        </div>
        <div
          class="column is-10">
          <r-label
            label="Votre actualité (mail quotidien)"
            :is-required="false"
            :for="'summary_email'"></r-label>
        </div>
        <div
          class="column is-2 has-text-right">
          <input
            id="summary_email"
            type="checkbox"
            name="summary_email"
            v-model="params.summary_email"
            class="switch is-success is-rounded is-small">
          <label
            for="summary_email"
            class="is-right"></label>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ManageNotification',
  data () {
    return {
      params: {}
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['isAdmin', 'isPromoteur'])
  },
  mounted () {
    this.params = {
      pk: this.currentUser.pk,
      email_alert_enabled: this.currentUser.email_alert_enabled,
      sms_alert_enabled: this.currentUser.sms_alert_enabled,
      option_alert: this.currentUser.option_alert,
      claim_alert: this.currentUser.claim_alert,
      reservation_and_sale_alert: this.currentUser.reservation_and_sale_alert,
      relation_partner_alert: this.currentUser.relation_partner_alert,
      push_alert_enabled: this.currentUser.push_alert_enabled,
      summary_email: this.currentUser.summary_email,
      lead_alert: this.currentUser.lead_alert
    }
  },
  methods: {
    submitQuickview () {
      this.$emit('submitQuickview', { results: this.params })
    }
  }
}
</script>
